import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';

export const Wrapper = styled('div')`
  ${media.mdUp`
    height: 470px;
  `}
  height: 440px;
`;
